'use strict';

exports.__esModule = true;
exports.default = QuTextarea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function QuTextarea(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    _style.Container,
    null,
    _react2.default.createElement(_style.Textarea, props),
    children && _react2.default.createElement(
      _style.Footer,
      null,
      children
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-textarea/index.js
// module id = 1212
// module chunks = 0